export default "__VITE_ASSET__BDqU5OVS__"